// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YPxU","option":"styles_option__3Ub9E","selected":"styles_selected__29ZzD"};